<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" @click="destroyElement">        
        <div class="u-window m-offer-modal">
            <div class="dialog-wrapper">
                <div class="title"></div>
                <ul v-if="shop_list.length > 0" class="ticket-list">
                    <li class="ticket-item" v-for="(item,index) in shop_list" :key="index">
                        <div class="status apply" v-if="item.state == 1"></div>
                        <div class="status dismiss" v-if="item.state == 2"></div>
                        <div class="t-title">
                            <div class="type" v-if="item.type == 1">{{ item.value }}</div>
                            <div class="type" v-if="item.type == 2">{{ item.value }}折</div>
                            <div class="slogen">{{ item.slogen }}</div>
                        </div>

                        <div class="t-detail">
                            <h5 v-if="item.type == 1">店铺满减券</h5>
                            <h5 v-if="item.type == 2">店铺折扣券</h5>
                            <div class="content"><span v-if="item.full > 0">满{{ item.full }}可用，</span>最多可抵扣{{ item.maxAmt }}</div>
                            <div class="time">{{ $global.activityTime }}</div>
                        </div>
                    </li>
                </ul>
                
                <div class="notice">历史累计消费奖励将在本期结束后清空并更新，请及时领取</div>

                <div class="u-btn i-know"></div>
            </div>       
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            shop_list : [],
            time : this.$global.activityTime,
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        //this.$toast('您有以下优惠劵可以使用~');
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },  
    },       
}
</script>

<style lang="scss" scoped>
.m-offer-modal{
    width: 625px;
    height: 445px;
    background-image: url(~@/assets/images/modal/bg-modal-offer.png);
}

.title{
    width: 516px;
    height: 52px;
    margin: 0 auto 23px;
    background-image: url(~@/assets/images/modal/title-offer.png);
}


.status {
    margin-left: 20px;
}

// .ticket-view .status.apply {
//     width: 49px;
//     height: 49px;
//     background-image: url(~@/assets/images/ticke-apply.png);
// }

// .ticket-view .status.dismiss {
//     width: 73px;
//     height: 89px;
//     background-image: url(~@/assets/images/ticket-dismiss.png);
// }

.ticket-list{
    .ticket-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 531px;
        height: 136px;
        margin: 0 auto 10px;
        padding: 0 10px 0 10px;
        // background-image: url(~@/assets/images/detail/ticket.png);
        background-image: url(~@/assets/images/modal/bg-ticket_new.png);

        .t-title{
            width: 134px;
            text-align: center;
        }

        .type{
            font-size: 60px;
            font-weight: 700;
            color: #b23700;
        }

        .slogen{
            color: #b23700;
        }

        .t-detail{
            width: 330px;
            color: #864b31;
            text-align: center;

            h5{
                font-size: 24px;
                margin-bottom: 12px;
            }

            .content{
                font-size: 20px;
            }

            .time{
                font-size: 20px;
            }
        }
    }
}

.notice{
    width: 531px;
    margin: 0 auto;
    text-align: center;
    color: #d33d27;
}

.u-btn.i-know{
    width: 186px;
    height: 56px;
    margin: 35px auto 0;
    background-image: url(~@/assets/images/modal/btn-know.png);           
}  
</style>
